import apiPath from '@/lib/apiPath';
// 根据环境区分海外版本和国内版本
export const isSingapore = import.meta.env.VITE_ENV.indexOf('singapore') !== -1;
// 系统消息类型
const SYSTEM_MSG_TYPE_LIST = {
  5: ' 分配客服',
  6: ' 结束會話',
  7: ' 轉接人工客服（企微不會下发这個）',
  8: ' 轉接接待',
  10: ' 重新开启會話',
  16: ' 语音/視頻通话',
  17: ' 系統訊息',
  21: ' 预约单訊息',
};

/** H5 转接成功通知（普通文本伪装系统消息，需与 aichat constants 保持一致） */
export const TRANSFER_SUCCESS_NOTICE = {
  marker: '[SYS_XIAOLING_TRANSFER_OK]',
  displayText: '用戶已成功轉接人工客服',
};

export const isTransferSuccessNotice = (text?: string) =>
  typeof text === 'string' && text.indexOf(TRANSFER_SUCCESS_NOTICE.marker) !== -1;

export const formatTransferSuccessNoticeText = (text?: string) =>
  isTransferSuccessNotice(text) ? TRANSFER_SUCCESS_NOTICE.displayText : text;

export const MSG_TYPE = {
  businessCard: '',
  chatRecord: '',
  groupInvitation: '',
  image: 2,
  applets: 13,
  text: 1,
  file: 12,
  video: 14,
  voice: 9,
  videoNumber: '',
  robot: 3,
  emojiImage: 15,
  radarLink: 11,
  leaveComment: 18,
  card: 19,
  business_customize: 20,
};

export const MSG_TYPE_TEXT: {
  [key: number]: string;
} = {
  1: 'text',
  2: 'image',
  3: 'robot',
  9: 'voice',
  11: 'radarLink',
  12: 'file',
  13: 'applets',
  14: 'video',
  15: 'emojiImage',
  18: 'leaveComment',
  19: 'card',
  20: 'business_customize',
  // businessCard: '',
  // chatRecord: '',
  // groupInvitation: '',
  // applets: '',
  // file: '',
  // video: '',
  // videoNumber: '',
};

export const MSG_TYPE_STRING: {
  [key: string]: string;
} = {
  image: '圖片',
  video: '視頻',
  file: '文件',
  videoNumber: '視頻号',
  businessCard: '名片',
  chatRecord: '聊天記錄',
  groupInvitation: '进群邀請',
  radarLink: '雷達鏈接',
  applets: '小程序',
  emojiImage: '表情包',
};

export const MSG_SEND_STATUS: { [key: string]: number } = {
  failed: 0,
  success: 1,
  sending: 2,
};

export const sessionDispatchOptions: { [key: string]: number } = Object.freeze({
  gzh: 4,
  h5: 1,
  qw: 5,
  ip: 6,
  wxkf: 7,
  group: 8,
});
export const sessionDispatchOptionsMap: { [key: number]: string } = Object.freeze({
  4: 'gzh',
  1: 'h5',
  5: 'qw',
  6: 'ip',
  7: 'wxkf',
  8: 'group',
});
export const sessionDispatchLabelOptions: { [key: string]: string } = Object.freeze({
  qw: '企微',
  h5: 'H5',
  gzh: 'GZH',
  ip: 'IP',
  wxkf: '微信客服',
  group: '企微群',
});

export const sourceTypeOptions: { [propName: number]: string } = {
  1: 'H5',
  2: 'app',
  3: '公众号',
  4: '企业微信',
};

export const aiAssistantFromUserType = {
  0: '用戶',
  1: '客服',
  2: '機器人',
  3: '系統訊息',
};

export const default_avatar = 'https://img-fe.tengzhihh.com/image/70660262f23e95-600x600.png';

export const aiAssistantAvatar = 'https://img-fe.tengzhihh.com/image/086594e5349a77-64x64.png';

export const momentBackgroundImg = 'http://im-service-zt.oss-cn-hangzhou.aliyuncs.com/image/9vp25s9ixps5q3qj3i8tc.jpg';

export const consultingTypeOptions: { [p: number]: string } = {
  0: '售前',
  1: '售後',
  2: '其他',
};

export const sessionTagTypeOptions = isSingapore
  ? [
    { name: '用戶标签', id: 3, tip: '（不支持群篩選）' },
    { name: '諮詢标签', id: 4, tip: '（不支持群篩選）' },
    { name: '最後一次联系時间', id: 6 },
  ]
  : [
    { name: '企微號名稱', id: 0 },
    { name: '接待人員', id: 1, personalDisabled: true },
    { name: '會話类型', id: 2 },
    { name: '用戶标签', id: 3, tip: '（不支持群篩選）' },
    { name: '諮詢标签', id: 4, tip: '（不支持群篩選）' },
    { name: '企微標籤', id: 5, tip: '（不支持群篩選）' },
    { name: '最後一次联系時间', id: 6 },
  ];
export const sessionTagRuleOptions = [
  { name: '包含', id: 0 },
  { name: '不包含', id: 1 },
];
export const sessionTagCsTypeOptions = [
  { name: 'app/h5', id: 1 },
  { name: '群聊', id: 8 },
  { name: '公号', id: 4 },
  { name: '企微', id: 5 },
  { name: '虛擬機器人', id: 6 },
];

export const allRuleOperator = {
  eq: '等於',
  neq: '不等於',
  contain: '包含',
  not_contain: '不包含',
  gt: '大於',
  gte: '大於等於',
  lt: '小於',
  lte: '小於等於',
};

export const attributeTypeOptions = [
  {
    name: '文本',
    id: 0,
    rules: [
      { id: 'eq', name: '等於' },
      { id: 'neq', name: '不等於' },
      { id: 'contain', name: '包含' },
      { id: 'not_contain', name: '不包含' },
    ],
  },
  {
    name: '數字',
    id: 1,
    rules: [
      { id: 'eq', name: '等於' },
      { id: 'neq', name: '不等於' },
      { id: 'gt', name: '大於' },
      { id: 'gte', name: '大於等於' },
      { id: 'lt', name: '小於' },
      { id: 'lte', name: '小於等於' },
    ],
  },
  { name: '布尔', id: 2, rules: [{ id: 'eq', name: '等於' }] },
  {
    name: '數组',
    id: 3,
    rules: [
      { id: 'eq', name: '等於' },
      { id: 'neq', name: '不等於' },
      { id: 'gt', name: '大於' },
      { id: 'gte', name: '大於等於' },
      { id: 'lt', name: '小於' },
      { id: 'lte', name: '小於等於' },
      { id: 'contain', name: '包含' },
      { id: 'not_contain', name: '不包含' },
    ],
  },
  {
    name: '枚举单选',
    id: 4,
    rules: [
      { id: 'eq', name: '等於' },
      { id: 'neq', name: '不等於' },
    ],
  },
  {
    name: '枚举多选',
    id: 5,
    rules: [
      { id: 'eq', name: '等於' },
      { id: 'neq', name: '不等於' },
      { id: 'gt', name: '大於' },
      { id: 'gte', name: '大於等於' },
      { id: 'lt', name: '小於' },
      { id: 'lte', name: '小於等於' },
      { id: 'contain', name: '包含' },
      { id: 'not_contain', name: '不包含' },
    ],
  },
];

// 接待状态
export const receiveStatusOptions = [
  { id: 0, name: '待接待' },
  { id: 1, name: '接待中' },
  { id: 2, name: '已轉接', disabled: true },
  { id: 3, name: '已结束（用戶離線）' },
  { id: 4, name: '客服结束接待' },
  { id: 5, name: '公海池回收' },
];

// 性别
export const genderOptions = [
  { id: 0, name: '未知' },
  { id: 1, name: '男' },
  { id: 2, name: '女' },
];
export const genderMap: { [key: number]: string } = {
  0: '未知',
  1: '男',
  2: '女',
};

export const orderPayStatusOptions = [
  { val: 0, label: '待支付', adminLabel: '未支付' },
  { val: 1, label: '已支付', adminLabel: '已支付' },
  { val: 2, label: '全额退款', adminLabel: '已退款' },
  { val: 3, label: '部分退款', adminLabel: '部分退款' },
  // { val: 4, label: '订单已过期', adminLabel: '订单已过期 }
];
// 订单用户添加方式
export const orderUserAddWayOptions = [
  { val: 0, label: '未知來源' },
  { val: 1, label: '扫描二维码' },
  { val: 2, label: '搜索手機号' },
  { val: 3, label: '名片分享' },
  { val: 4, label: '群聊' },
  { val: 5, label: '手機通讯录' },
  { val: 6, label: '微信联系人' },
  { val: 8, label: '安装第三方應用時自動添加的客服人員' },
  { val: 9, label: '搜索邮箱' },
  { val: 10, label: '視頻号添加' },
  { val: 11, label: '通過日程参與人添加' },
  { val: 12, label: '通過會议参與人添加' },
  { val: 13, label: '添加微信好友對應的企业微信' },
  { val: 14, label: '通過智慧硬件专属客服添加' },
  { val: 15, label: '通過上门服務客服添加' },
  { val: 16, label: '通過獲客链接添加' },
  { val: 17, label: '通過定制开发添加' },
  { val: 18, label: '通過需求回復添加' },
  { val: 21, label: '通過第三方售前客服添加' },
  { val: 22, label: '通過可能的商务伙伴添加' },
  { val: 24, label: '通過接受微信賬號收到的好友申請添加' },
  { val: 201, label: '內部成員共享' },
  { val: 202, label: '管理員/負責人分配' },
];

export const userTagShowTypeOptions = [
  { id: 0, name: '所有人可见' },
  { id: 1, name: '本團隊所有人可见' },
  { id: 2, name: '仅限本團隊管理員可见' },
  { id: 3, name: '管理員（不区分團隊）可见' },
  { id: 4, name: '仅限創建人本人可见' },
];

// 收藏夹类型
export const favoriteOptions = [
  {
    label: '文本',
    name: 'text',
  },
  {
    label: '圖片',
    name: 'image',
  },
  // 第三方扫码登录不支持发送语音
  // {
  //   label: '语音',
  //   name: 'voice',
  // },
  // {
  //   label: '小程序',
  //   name: 'applets',
  // },
  {
    label: '視頻',
    name: 'video',
  },
  // {
  //   label: '图文',
  //   name: 'image_text',
  // },
  {
    label: '文件',
    name: 'file',
  },
];

// 话术推荐
export const recommendSourceList = [
  { type: 0, label: '不推薦', name: '不推薦' },
  {
    type: 1,
    label: '小问推薦',
    name: '小问',
    url: apiPath.xiaoWenGPT.getAnswerList,
    max_length: 100,
    num_return_sequences: 5,
  },
  {
    type: 2,
    label: '小机推薦',
    name: '小机',
    url: apiPath.xiaoJiGPT.getAnswerList,
    max_length: undefined,
    isXiaoJi: true,
    num_return_sequences: 2,
  },
  {
    type: 3,
    label: '小机推薦(常用話術)',
    name: '小机(常用話術)',
    url: apiPath.xiaoJiGPT.getConsultCandidatesRecommand,
    max_length: 1024,
    isXiaoJi: true,
    num_return_sequences: 1,
  },
  {
    type: 4,
    label: '小机推薦(售後部模式)',
    name: '小机(售後)',
    url: apiPath.xiaoJiGPT.getAnswerList,
    max_length: undefined,
    isXiaoJi: true,
    num_return_sequences: 1,
  },
];

export const userInfoDetailMenus = [
  {
    id: 'userInfo',
    label: '用戶詳情',
    group_show: false,
    only_info: true,
    actived_icon: 'https://img-fe.tengzhihh.com/image/db16422ed972c4-48x48.png',
    deactivated_icon: '',
  },
  {
    id: 'userInfo',
    label: '群詳情',
    group_show: true,
    only_info: true,
    only_group: true,
    actived_icon: 'https://img-fe.tengzhihh.com/image/db16422ed972c4-48x48.png',
    deactivated_icon: '',
  },
  {
    id: 'wechatGuide',
    label: '用戶轨迹',
    group_show: false,
    only_info: true,
    actived_icon: 'https://img-fe.tengzhihh.com/image/8b6debf4f086791b84c97aba529bcba9-64x64.png',
    deactivated_icon: '',
  },
  {
    id: 'quickReply',
    label: '快捷回復',
    group_show: true,
    actived_icon: 'https://img-fe.tengzhihh.com/image/d94529e891157b-48x48.png',
    deactivated_icon: '',
  },
  {
    id: 'order',
    label: '訂單列表',
    only_info: true,
    actived_icon: 'https://img-fe.tengzhihh.com/image/fce3f9e0104faf-48x48.png',
    deactivated_icon: '',
  },
  {
    id: 'archives',
    label: '档案信息',
    only_info: true,
    actived_icon: 'https://img-fe.tengzhihh.com/image/084e3777778232-48x48.png',
    deactivated_icon: '',
  },
  {
    id: 'reservation',
    label: '预约信息',
    only_info: true,
    actived_icon: 'https://img-fe.tengzhihh.com/image/0deed775469fae-48x48.png',
    deactivated_icon: '',
  },
  {
    id: 'AIAssistant',
    label: 'AI助手-命理命盘',
    title: '很久Ai',
    titleTip: '內容由數字中心整合，并辅助進行接待服務',
    tagLabel: '命理命盘',
    actived_icon: 'https://img-fe.tengzhihh.com/image/2ebce7fcf98653e3f383f5dabd6684c7-48x48.png',
  },
  {
    id: 'marketingPsychology',
    label: 'AI助手-营销心理',
    title: '很久Ai',
    titleTip: '內容由數字中心整合，并辅助進行接待服務',
    tagLabel: '营销心理',
    actived_icon: 'https://img-fe.tengzhihh.com/image/e50953e048046f74edb84ef6f99c81cb-48x48.png',
  },
  {
    id: 'userTrajectory',
    label: 'AI助手-Turbo',
    title: 'AI助手-Turbo',
    titleTip: '內容由數字AI模型生成，生成用戶档案，提高接待效率',
    only_info: true,
    actived_icon: 'https://img-fe.tengzhihh.com/image/f08c7a8066c91c99837839b5558aa249.png',
  },
];
// 犯太岁解析:
export const taisuiDetail = {
  刑太岁:
    '刑太岁: 刑值相刑，象征刑法，有刑伤之意, 所以刑太岁的生肖在犯太岁之年, 很容易受到司法或着行政方面的困扰，因自身的磁场受到损害，所以在犯太岁之年,很容易发生诸如血光之灾等伤害自己身体的事件发生，造成自己的事业，家庭等個方面都會受到很大的影响。',
  冲太岁:
    '冲太岁: 冲即使相冲，象征着冲击，对抗之意，也称为反吟, 岁破。如果我们的属相與太岁相冲的话，自然會非不断，阻力重重。所以在犯太岁的生肖中，以冲太岁是最为严重的，所以犯冲太岁的朋友，在事业上需费心费力，处处小心, 当然健康, 感情等方面也會受到很大的影响，2018年是戊成狗年，属龙的人冲太岁, 所以生肖龙在这一年要格外注意。',
  破太岁:
    '破太岁: 破象征着破损，破裂的意思。凡遇破太岁的生肖，需多注意自己的感情和事业因为破太岁會产生分裂的磁场，对感情和事业尤为不利。破太岁與刑太岁和冲太岁不同，他會专门破坏稳定和妥当的事情，如杲你正遇破太岁的话，应尽快化解掉这种不利的磁场，否则很容易发生意外的变故，2018年戌未相破，属羊的朋友正值破太岁。',
  害太岁:
    '害太岁: 害象征着不合, 有伤意之意，他與前三者相比，最明显的就是它很难與其他属性的磁场相融合，所以害太岁不會对我们的健康，事业, 感情造成很大的伤害。但是害太岁代表着互相争斗对峙，很容易产生仇恨，而引发灾害。2018戊戌狗年酉戌相害，所以生肖属鸡的人，一定要注意。',
};

export const weekdays = [
  { id: 1, name: '週一', index: 1 },
  { id: 2, name: '週二', index: 2 },
  { id: 3, name: '週三', index: 3 },
  { id: 4, name: '週四', index: 4 },
  { id: 5, name: '週五', index: 5 },
  { id: 6, name: '週六', index: 6 },
  { id: 7, name: '週日', index: 0 },
];

export const scheduleStatusOptions = [
  { id: 0, name: '已预约' },
  { id: 1, name: '待签到' },
  { id: 2, name: '已服務' },
  { id: 3, name: '已過期' },
  { id: 4, name: '已取消' },
];

// 客户管理来源类别
export const customerStateTypeOptions = [
  { id: 0, name: '未知' },
  { id: 1, name: '渠道活碼' },
  { id: 2, name: '場景活碼' },
  { id: 3, name: '個微' },
  { id: 4, name: '微信客服' },
  { id: 5, name: '小程序' },
  { id: 6, name: '企微工作台推薦码' },
  { id: 7, name: '知你企微推薦码' },
  { id: 8, name: '聯繫碼' },
  { id: 9, name: '企飞活碼' },
  { id: 10, name: '微伴活碼' },
  { id: 11, name: '活碼兜底企微码' },
];

// IP群发市场渠道选项（业务提供）
export const marketChannelList = Object.freeze([
  {
    id: 'yffh_gbqu_00001',
    name: 'android_huawei_market',
  },
  {
    id: 'yffh_mia9_00001',
    name: 'android_xiaomi_market',
  },
  {
    id: 'yffh_emou_00001',
    name: 'android_vivo_market',
  },
  {
    id: 'yffh_igcf_00001',
    name: 'android_oppo_market',
  },
  {
    id: 'yffh_it7s_00001',
    name: 'android_meizu_market',
  },
  {
    id: 'yffh_fcj4_00001',
    name: 'android_qq_market',
  },
  {
    id: 'yffh_xdsr_00001',
    name: 'android_baidu_market',
  },
  {
    id: 'yffh_g5os_00001',
    name: 'android_360_market',
  },
  {
    id: 'yffh_bkgr_00001',
    name: 'android_lenovo_market',
  },
  {
    id: 'yffh_typ4_00001',
    name: 'android_lteacher_market',
  },
  {
    id: 'yffh_rvkc_00001',
    name: 'tengxun_xiaochengxu',
  },
  {
    id: 'yffh_by0a_00001',
    name: 'apple_app_store',
  },
  {
    id: 'yffh_sitg_00001',
    name: 'android_honor_market',
  },
  {
    id: 'yffh_jcxg_00001',
    name: 'android_wxs_syfh',
  },
]);

export const isProd = !/sandbox|localhost|127\.0.0.1|10.1.200|10.1.161/i.test(location.hostname);
// 云真机域名
export const yunZhenJiUrl = 'https://yzj.miaokol.com';
// AI助手域名
export const AIToolUrl = isProd ? 'https://ai-tools.qiyuan333.cn' : 'https://sandbox-ai-tools.linghit.cn';

// 支付页DC访问路径
export const DCPaymentBaseURL = isProd
  ? 'https://servicecenter-pay.tianjinqihua4.cn/serviceCenterPay'
  : 'https://sandbox-dc.jinhuihh.com/serviceCenterPay';
// 社群收款页面
export const DCCommunityCollectionURL = isProd
  ? 'https://servicecenter-pay.tianjinqihua4.cn/serviceCenterPay/community'
  : 'https://sandbox-dc.jinhuihh.com/serviceCenterPay/community';
// 支付结果页DC访问路径
export const paymentReturnUrl = isProd
  ? 'https://servicecenter-pay.tianjinqihua4.cn/serviceCenterPay/paymentResult'
  : 'https://sandbox-dc.jinhuihh.com/serviceCenterPay/paymentResult';
// 资源位后台
export const operationAdminUrl = isProd
  ? 'https://operation-admin.fxz365.com/resource/pattern'
  : 'https://sandbox-operation-admin.fxz365.com/resource/pattern';

export const orderCenterAdminUrl = isProd
  ? 'https://orders-center.linghit.cn//settingUp/paymentAgreement'
  : 'https://sandbox-order-center.linghit.cn/settingUp/paymentAgreement';

// 开单插件域名
export const BillingToolUrl = isProd ? 'https://ai-tools.qiyuan333.cn' : 'https://sandbox-ai-tools.linghit.cn';

// 企微工作台域名
export const WokrBenchUrl = isProd ? 'https://dc.gzyt123.cn' : 'https://sandbox-dc.jinhuihh.com';
// 录单产品分类
export const productTypeOptions = [
  { label: '常卖產品', value: 'always', origin: 2 },
  { label: '收藏產品', value: 'collect', origin: 3 },
  { label: '最近上架', value: 'new', origin: 4 },
];

// 收款需要关联产品的团队ID
export const needContactProductTeamIds = JSON.parse(import.meta.env.VITE_NEED_CONTACT_PRODUCT_TEAM_IDS || '[]');

// 团队角色
export const teamMemberTypeOptions = [
  { id: 0, name: '團隊成員' },
  { id: 1, name: '團隊負責人' },
];

// 群发消息类型
export const groupSendMsgTypeOptions = [
  { id: 0, name: '無' },
  { id: 1, name: '文字訊息' },
  { id: 2, name: '圖片訊息' },
  { id: 3, name: '雷达訊息' },
  { id: 4, name: '視頻訊息' },
  { id: 100, name: '复合訊息' },
];

// 高级群发任务状态
export const advancedGroupSendStatusOptions = [
  { id: 0, name: '創建中', type: '' },
  { id: 1, name: '待執行', type: 'info' },
  { id: 2, name: '執行中', type: 'warning' },
  { id: 3, name: '运行完成', type: 'success' },
  { id: 4, name: '任務失敗', type: 'danger' },
  { id: 5, name: '已取消', type: '' },
];

// 高级群发消息类型
export const advancedGroupSendMsgTypeOptions = [
  { id: 1, name: '文本訊息' },
  { id: 2, name: '圖片訊息' },
  { id: 3, name: '雷達鏈接' },
  { id: 4, name: '群聊邀請訊息' },
  { id: 5, name: '視頻訊息' },
  { id: 6, name: '小程序訊息' },
  { id: 7, name: '批量提醒用戶上線訊息' },
  { id: 100, name: '复合訊息' },
];
// 翻译选项
export const languageSourceOptions = [
  { id: 'zh', name: '中文简体' },
  { id: 'zh-tw', name: '中文繁体' },
  { id: 'en', name: '英文' },
  { id: 'yue', name: '粤语' },
];

// 下载中心状态
export const downloadCenterStatusOptions = [
  { id: 0, name: '數據處理中', type: 'info' },
  { id: 1, name: '文件上傳中', type: 'primary' },
  { id: 2, name: '導出成功', type: 'success' },
  { id: 3, name: '導出失敗', type: 'danger' },
];
// 文件类型图标
export const fileSuffixOptions = [
  {
    suffix: ['pdf', 'PDF'],
    icon: 'https://img-fe.tengzhihh.com/image/0ef036abdd732772f121bb5419880258-60x60.png',
    downloadIcon: 'https://img-fe.tengzhihh.com/image/5e302df9a77002af16fa2086ddab51a0-60x60.png',
  },
  {
    suffix: ['ppt', 'PPT'],
    icon: 'https://img-fe.tengzhihh.com/image/ef111605e346754d8a62aa52ae8acb70-60x60.png',
    downloadIcon: 'https://img-fe.tengzhihh.com/image/2934dc7390a6d1298ae64a0afa853de0-60x60.png',
  },
  {
    suffix: ['doc', 'docx', 'DOC', 'DOCX'],
    icon: 'https://img-fe.tengzhihh.com/image/f4f038f4cd2d6085779f2b3083e81be5-60x60.png',
    downloadIcon: 'https://img-fe.tengzhihh.com/image/1cf7221ddba8b2bb8587de383688850d-60x60.png',
  },
  {
    suffix: ['xls', 'xlsx', 'XLS', 'XLSX'],
    icon: 'https://img-fe.tengzhihh.com/image/a063832bc46f6b25b6b9955e398bd30a-60x60.png',
    downloadIcon: 'https://img-fe.tengzhihh.com/image/0a28af19130cab39af8f5e9760029220-60x60.png',
  },
  {
    suffix: ['txt', 'TXT'],
    icon: 'https://img-fe.tengzhihh.com/image/a25b7fd1a07f931d811a47dfdeb74ad0-60x60.png',
    downloadIcon: 'https://img-fe.tengzhihh.com/image/7dcb7123a326dc6cf12777ec93f8107b-60x60.png',
  },
  {
    suffix: ['zip', 'ZIP', 'ara', 'ARA'],
    icon: 'https://img-fe.tengzhihh.com/image/0fb717a82f2b48176e893ff11d09ce1c-60x60.png',
    downloadIcon: 'https://img-fe.tengzhihh.com/image/138a2a36a76a2f4552842a74b45fef7f-60x60.png',
  },
];
